import React from 'react';
import { useRownd } from '@rownd/react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';

const Navigation: React.FC = () => {
  const { is_authenticated, requestSignIn, signOut, user } = useRownd();

  return (
    <AppBar position="static" className="bg-gradient-to-r from-purple-700 to-blue-500">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Link to="/" className="text-white no-underline">
            VIBE Coding
          </Link>
        </Typography>
        <Box className="space-x-2">
          <Button color="inherit" component={Link} to="/">
            Home
          </Button>
          <Button color="inherit" component={Link} to="/about">
            About
          </Button>
          <Button color="inherit" component={Link} to="/pricing">
            Pricing
          </Button>
          <Button color="inherit" component={Link} to="/resources">
            Resources
          </Button>
          {is_authenticated ? (
            <>
              <Button color="inherit" component={Link} to="/dashboard">
                Dashboard
              </Button>
              <Button 
                color="inherit" 
                onClick={signOut}
                variant="outlined"
                className="ml-2"
              >
                Sign Out
              </Button>
              <Typography variant="body2" className="ml-2 text-white">
                Hello, {user.data.first_name || 'User'}
              </Typography>
            </>
          ) : (
            <Button 
              color="inherit" 
              onClick={() => requestSignIn()}
              variant="outlined"
              className="ml-2"
            >
              Sign In
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation; 